// extracted by mini-css-extract-plugin
export default {"root":"E0p7gF","name":"ZbujfJ","mobile":"ku8q1G"};